// For OMS
export const enum OmsLocales {
  EN = 'en',
  BN = 'bn',
  TR = 'tr',
  EN_IND = 'in',
}

// For NextJs, Strapi
export const enum Locales {
  EN_BD = 'en',
  BN_BD = 'bn-BD',
  EN_AE = 'en-AE',
  EN_TR = 'en-TR',
  TR_TR = 'tr-TR',
  EN_TK = 'en-TK', // Proxy locale for en-TR used in Strapi
  EN_IN = 'en-IN',
}

export const bdLocales = [Locales.EN_BD, Locales.BN_BD];
export const aeLocales = [Locales.EN_AE];
export const trLocales = [Locales.EN_TR, Locales.TR_TR];
export const indLocales = [Locales.EN_IN];

export const LocaleLabels = {
  en: 'English',
  bn: 'Bangla',
  ae: 'English',
  tr: 'Turkish',
} as const;

export const DefaultLocales = {
  uae: Locales.EN_AE,
  tr: Locales.TR_TR,
  bd: Locales.BN_BD,
  ind: Locales.EN_IN,
} as const;
